import { useEntriesSumByTask } from '@features/time-logging/hooks/useEntrySums'
import { useWeekScope } from '@hooks/useWeekScope'
import { ReactNode } from 'react'

export const TaskTotalById = ({
  taskId,
  children,
}: {
  taskId: number
  children: (total: number) => ReactNode
}) => {
  const { end, start } = useWeekScope()
  const total = useEntriesSumByTask(taskId, start, end)

  return <>{children(total)}</>
}
